<template>
  <div class="main-content">
    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
    <div v-if="!loading">

      <div class="card">
        <div class="card-body">
          <div class="mb-2">
            <LoadingButton
              title="Обновить список запросов"
              type="button"
              :loading="btnLoading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="getRequests"
              className="btn btn-outline-success br-0"
            />
          </div>
          <div class="mb-2">
            <LoadingButton
              title="Новый запрос"
              type="button"
              :loading="btnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="newRequest"
              className="btn btn-outline-info br-0"
            />
          </div>
          <div class="flex">
            <template v-if="dialogs && dialogs.length">
              <div class="w-100p chat_list">
                <ChatList
                  :dialogs="dialogs"
                  :displayDetails="{'orderId': true}"
                  :onSelect="onSelectDialog"
                  :selectedDialogId="selectedDialog.id"
                />
              </div>
              <div class="messages_block">
                <template v-if="selectedDialog && selectedDialog.id && activeMessages">
                  <Messages
                    :hideNames="true"
                    :dialogId="selectedDialog.id"
                    :dialogAccepted="+selectedDialog.user_id === $currentUID || !!selectedDialog.is_accepted"
                    :messages="activeMessages"
                    :updateDialog="() => getRequests(true)"
                  />
                </template>
                <template v-else>
                  <h5 class="p-2">Выберите диалог</h5>
                </template>

                <template v-if="selectedDialog && selectedDialog.id && +selectedDialog.user_id === $currentUID">
                  <div class="text-right">
                    <LoadingButton
                      title="Вопрос решен, закрыть запрос"
                      type="button"
                      :loading="btnLoading"
                      :color="$constants.SUCCESS_COLOR"
                      :onClick="closeDialog"
                      className="btn btn-outline-success"
                    />
                  </div>
                </template>

              </div>
            </template>
            <template v-else>
              <div class="alert alert-info">
                <h4>Нет активных диалогов</h4>
              </div>
            </template>
          </div>
        </div>
      </div>


      <!--      <template v-if="!records || !records.length">-->
      <!--        <div class="card">-->
      <!--          <div class="card-body">-->
      <!--            <p>Запросов на корректуру не найдено</p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </template>-->
      <!--      <template v-else>-->
      <!--        <div class="card" v-for="record in records">-->
      <!--          <div class="card-body">-->
      <!--            <div class="">-->
      <!--              <span v-if="record.order_id">Заявка: <strong>{{ (record.order_id + '').substr(-4) }}</strong></span>-->
      <!--              <span :class='`badge ${record.className} pull-right`'>{{ record.status_title }}</span>-->
      <!--            </div>-->
      <!--            <p>{{ record.text }}</p>-->
      <!--            <p class="text-muted text-right">{{ moment(record.created_at, 'HH:mm') }}</p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </template>-->
    </div>
  </div>
</template>

<script>
import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import moment from "moment";
import ChatList from "@/components/chat/components/ChatList"
import Messages from "@/components/chat/components/Messages";
import {chatUpdated} from "@/eventsBus";

export default {
  components: {
    LoadingButton,
    ChatList,
    Messages,
  },
  data() {
    return {
      loading: false,
      btnLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      records: null,
      dialogs: null,
      selectedDialog: {},
      activeMessages: null,
    }
  },
  mounted() {
    this.getRequests();
    chatUpdated.$on("updateChat", (data) => {
      const dialogIndex = this.dialogs.findIndex((d) => +d.id === +data.dialog_id);
      if (dialogIndex !== -1) {
        if (data.messages) {
          this.dialogs[dialogIndex].messages = data.messages;
        }
        if (data.dialog) {
          this.dialogs[dialogIndex] = {...this.dialogs[dialogIndex], ...data.dialog}
        }
        this.dialogs = this.dialogs.filter((d) => d && +d.is_active);
        if (this.selectedDialog && this.selectedDialog.id) {
          this.onSelectDialog(this.selectedDialog.id);
        }
      }
    });
  },
  methods: {
    async closeDialog() {
      this.btnLoading = true;
      const selectedDialogId = this.selectedDialog.id;
      const {data} = await api.post('/new/chat/update', {
        type: 'closeDialog',
        dialog_id: selectedDialogId,
      })
      if (data.success) {
        this.dialogs = this.dialogs.filter((d) => d && d.id !== selectedDialogId);
        toastr["success"]('Запрос закрыт', 'Успешно');
        this.activeMessages = null;
        this.selectedDialog = {};
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.btnLoading = false;
    },
    async newRequest() {
      this.btnLoading = true;
      const {data} = await api.post('/new/chat/dialog', {
        type: 4
      })
      if (data.success) {
        data.dialog.messages = [];
        this.dialogs.push(data.dialog);
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.btnLoading = false;
    },
    onSelectDialog(dialogId) {
      const dialog = this.dialogs.find((d) => +d.id === +dialogId);
      this.selectedDialog = dialog;
      this.activeMessages = dialog && +dialog.is_active ? dialog.messages : null;
    },
    async getRequests(silent = false) {
      this.loading = !silent;
      const {data} = await api.index('orders/gerRunnerRequests');
      if (data.success) {
        this.dialogs = data.dialogs;
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.loading = false;
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}
</script>

<style scoped>
.w-100p {
  flex: 0 0 100px;
}

p {
  margin-bottom: 2px;
}

.br-0 {
  width: 100%;
  border-radius: 0;
}

.card {
  margin-bottom: 5px;
}

.chat_list {
  max-height: 70vh;
  overflow: auto;
}

.messages_block {
  flex-grow: 1;
  min-height: 200px;
}
</style>
